// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__35IBp","image":"Header_image__GSyad","name":"Header_name__3ij8X","info":"Header_info__2TtTN","infoRow":"Header_infoRow__3qg6H"};